import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import {
    RecurrenceFrequencyTypeEnumData,
    type BookingRawData,
    type RecurrenceFrequencyTypeEnumDataEntry,
    type RecurringMeetingSearchFiltersType,
} from '@/Shared/AutoGenerated/Main'
import RecurrenceSettings from '@/App/Service/Entity/RecurrenceSettings'
import BookingID from '@/App/Booking/Booking/Entity/BookingID'

export default class Booking {
    constructor(
        public readonly id: BookingID,
        public readonly uniqueCode: string,
        public readonly snapshotRecurrenceSettings: RecurrenceSettings,
        public readonly numberOfScheduledMeetings: number,
        public readonly snapshotIsPaymentRequired: boolean,
    ) {
        ensureNoUndefinedProperties(this)
    }

    isRecurring(): boolean {
        return this.snapshotRecurrenceSettings.isRecurring()
    }

    getNumberOfSessionsDescription(): string {
        if (!this.isRecurring()) {
            throw new Error('Meeting is not recurring')
        }

        return `${this.numberOfScheduledMeetings} sessions`
    }

    getRecurrenceFrequencyTypeEnumData(): RecurrenceFrequencyTypeEnumDataEntry {
        return RecurrenceFrequencyTypeEnumData[
            this.snapshotRecurrenceSettings.frequencyType
        ]
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: BookingRawData): Booking {
        return new Booking(
            new BookingID(entityData.id),
            entityData.uniqueCode,
            RecurrenceSettings.hydrateSingle(
                entityData.snapshotRecurrenceSettings,
            ),
            entityData.numberOfScheduledMeetings,
            entityData.snapshotIsPaymentRequired,
        )
    }

    static hydrateMultiple(entitiesData: BookingRawData[]): Booking[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
